export default {
    name: 'table_header_name',
    category: 'table_header_category',
    added: 'table_header_added',
    actions: 'table_header_actions',
    cancel_confirmation_title: 'cancel_confirmation_title',
    cancel_confirmation_button_label: 'cancel_confirmation_button',
    cancel_confirmation_question: 'cancel_confirmation_question',
};
